exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".image {\n    margin: 0;\n    padding: 0;\n}\n\n.block-desc{\n    position: relative;\n    top: -40px;\n}", ""]);

